<div class="row">
  <div
  [innerHTML]="description"
  class="product-description col-md-12"
  ></div>
  
  <div class="final-price col-md-12">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-9"></div>
      <div class="col-md-3 order-btn-row">
        <div
          class="order-btn-detail order-btn-bottom"
          (click)="continueOrder(1)"
        >
          <div class="final-price-num">{{ finalPrice }} ₪</div>
          להמשך מילוי פרטי הזמנה
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
